import React , { useEffect } from 'react';
import '../LegalPages.css';
import background from '../assets/img4.png';

export function Terms() {
        useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="legal-page" style={{ backgroundImage: `url(${background})` }}>
            <div className="overlay" />
            <div className="legal-content">
                <h1>Términos y Condiciones</h1>
                <p className="update-date">Última actualización: 15 de noviembre de 2025</p>

                <div className="legal-text">

                    <p>
                        Al acceder y utilizar la aplicación ChefSkills ("nosotros", "nuestro" o "la app"),
                        aceptas los presentes Términos y Condiciones. Si no estás de acuerdo con alguno de ellos,
                        por favor, no utilices la aplicación.
                    </p>

                    <h2>1. Uso de la Aplicación</h2>
                    <p>
                        ChefSkills es una aplicación móvil que ofrece recetas, técnicas culinarias,
                        recomendaciones personalizadas y funcionalidades adicionales mediante inteligencia
                        artificial. La aplicación puede mostrar anuncios, salvo que el usuario contrate un plan
                        premium que elimine dicha publicidad.
                    </p>
                    <p>
                        Te comprometes a utilizar la app únicamente para fines lícitos
                        y de acuerdo con las leyes aplicables.
                    </p>

                    <h2>2. Registro y Cuenta de Usuario</h2>
                    <p>
                        Para acceder a ciertas funcionalidades, es obligatorio iniciar sesión mediante
                        Google (Firebase Authentication). Eres responsable de mantener la seguridad de
                        tu cuenta y de notificar cualquier acceso no autorizado.
                    </p>

                    <h2>3. Contenido del Usuario</h2>
                    <p>
                        Los usuarios pueden interactuar con el contenido de la app, incluyendo marcar favoritos,
                        guardar preferencias o calificar recetas. En algunas versiones futuras, los usuarios
                        podrán añadir notas o imágenes opcionales.
                    </p>
                    <p>
                        Mantienes los derechos de cualquier contenido generado por ti. No obstante,
                        otorgas a ChefSkills una licencia no exclusiva y sublicenciable para mostrar,
                        procesar o utilizar dicho contenido dentro de la app para mejorar tu experiencia.
                    </p>

                    <h2>4. Suscripciones y Pagos</h2>
                    <p>
                        ChefSkills ofrece planes premium mediante suscripción. La gestión de pagos se realiza
                        exclusivamente a través de Google Play Billing. No almacenamos información bancaria
                        ni métodos de pago.
                    </p>
                    <p>
                        Las suscripciones se renuevan automáticamente a menos que las canceles a través
                        de tu cuenta de Google Play.
                    </p>

                    <h2>5. Propiedad Intelectual</h2>
                    <p>
                        Todo el contenido de ChefSkills (incluyendo recetas, textos, imágenes, íconos, ilustraciones,
                        código, logotipos y gráficos) es propiedad de ChefSkills o sus respectivos creadores
                        y está protegido por leyes de propiedad intelectual. No está permitido reproducir,
                        distribuir ni modificar el contenido sin autorización previa.
                    </p>

                    <h2>6. Privacidad</h2>
                    <p>
                        El tratamiento de tus datos personales se rige por nuestra
                        <strong> Política de Privacidad</strong>, disponible en:
                    </p>
                    <p>
                        <a href="/privacy" className="legal-link">
                            https://chefskills.app/privacy
                        </a>
                    </p>

                    <h2>7. Modificaciones a los Términos</h2>
                    <p>
                        Podemos modificar estos Términos y Condiciones en cualquier momento. Te notificaremos
                        sobre cambios importantes a través de la app. El uso continuado de ChefSkills después
                        de una modificación constituye tu aceptación de los nuevos términos.
                    </p>

                    <h2>8. Responsabilidad del Usuario</h2>
                    <p>
                        Aceptas no utilizar ChefSkills para actividades ilícitas, difamatorias o que puedan
                        afectar a terceros. También aceptas no intentar manipular o alterar el funcionamiento
                        de la app.
                    </p>

                    <h2>9. Limitación de Responsabilidad</h2>
                    <p>
                        ChefSkills no será responsable de daños directos, indirectos, incidentales o consecuentes
                        derivados del uso o la imposibilidad de usar la app. No garantizamos que la app esté libre
                        de errores o interrupciones.
                    </p>

                    <h2>10. Jurisdicción</h2>
                    <p>
                        Estos términos se rigen por las leyes de Chile, y cualquier disputa relacionada con la app
                        será resuelta ante los tribunales competentes del país.
                    </p>

                    <h2>11. Contacto</h2>
                    <p>
                        Si tienes preguntas o inquietudes sobre estos Términos y Condiciones, contáctanos en:
                        <br /><strong>chefskills.app@gmail.com</strong>
                    </p>

                </div>
            </div>
        </div>
    );
}

export default Terms;
